/**************************************************
 * Nombre:       Dialogo_Anuncios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {guardarFechaAct} from "../../Servicios/BD/Actualizadores/guardarFechaAct";
import Formulario_Artesano from "../Formularios/Formulario_Artesano";

const Dialogo_Anuncios = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()
        iniciarCarga('Subiendo Datos')
        let doxImg = await subirImagenHostingFile(entidad.img)
        entidad.img = doxImg.data


        let dox = await guardarDoc('anuncio', entidad)
        await guardarFechaAct('anuncio')
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('anuncio', datos.id)
        terminar({aviso: 'Anuncio borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Artesano props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Anuncios